import PanelButton from './PanelButtonIndex';

export default PanelButton;